import { render, staticRenderFns } from "./SfDropdown.vue?vue&type=template&id=0a9e0af3&"
import script from "./SfDropdown.vue?vue&type=script&lang=js&"
export * from "./SfDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SfDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports